import styled from "styled-components";

export const FooterContainer = styled.footer`
  width: 100vw;
  background: ${({ theme }) => theme.colors.neutral[900]};
  padding: 40px;
  position: relative;
  z-index: 3;
  margin-top: 1rem;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 60px 0 30px;
  }
`;

export const FooterContent = styled.div`
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  gap: 30px;
  padding: 0 24px;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    gap: 40px;
    padding: 0 20px;
  }

  @media (max-width: 480px) {
    padding: 0 16px;
  }
`;

export const FooterColumn = styled.div`
  flex: 1;
  min-width: 200px;

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  li {
    margin-bottom: ${({ theme }) => theme.spacing.sm};
  }

  /* First column (About) should be slightly wider */
  &:first-child {
    flex: 1.5;
    min-width: 280px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    min-width: 100%;
    margin-bottom: ${({ theme }) => theme.spacing.lg};

    &:last-child {
      margin-bottom: 0;
    }
  }

  a {
    color: ${({ theme }) => theme.colors.neutral["500"]};
    text-decoration: none;
    font-size: ${({ theme }) => theme.typography.sizes.sm};
    transition: all 0.3s ease;

    &:hover {
      color: ${({ theme }) => theme.colors.neutral["400"]};
      text-decoration: underline;
    }
  }
`;

export const FooterHeading = styled.h4`
  font-size: ${({ theme }) => theme.typography.sizes.md};
  font-weight: ${({ theme }) => theme.typography.weights.bold};
  color: ${({ theme }) => theme.colors.neutral["300"]};
  margin-bottom: 20px;

  @media (max-width: 768px) {
    margin-bottom: 25px;
  }
`;

export const FooterText = styled.p`
  font-size: ${({ theme }) => theme.typography.sizes.sm};
  color: ${({ theme }) => theme.colors.neutral["600"]};
  margin-bottom: 20px;
  line-height: 1.6;
`;

export const ContactLink = styled.a`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: ${({ theme }) => theme.typography.sizes.sm};
  color: ${({ theme }) => theme.colors.neutral["500"]};
  text-decoration: none;
  margin-bottom: 15px;
  transition: color 0.3s ease;

  &:hover {
    color: ${({ theme }) => theme.colors.neutral["400"]};
  }

  @media (max-width: 768px) {
    justify-content: center;
  }
`;

export const SocialLinks = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 15px;

  a {
    color: ${({ theme }) => theme.colors.neutral["500"]};
    transition: all 0.3s ease;
    display: inline-flex;
    padding: 8px;
    
    &:hover {
      color: ${({ theme }) => theme.colors.neutral["400"]};
      transform: translateY(-2px);
    }
  }

  @media (max-width: 768px) {
    justify-content: center;
  }
`;

export const Copyright = styled.p`
  text-align: center;
  margin-top: 30px;
  font-size: ${({ theme }) => theme.typography.sizes.sm};
  color: ${({ theme }) => theme.colors.neutral["600"]};
  padding: 0 20px;

  @media (max-width: 768px) {
    margin-top: 40px;
    line-height: 1.5;
  }
`;

export const DisabledLink = styled.span`
  color: ${({ theme }) => theme.colors.neutral["500"]};
  font-size: ${({ theme }) => theme.typography.sizes.md};
  opacity: 0.6; /* Make it look inactive */
  cursor: not-allowed; /* Show a disabled cursor */
  pointer-events: none; /* Prevent clicks */
  display: inline-block;
  transition: opacity 0.3s ease;
`;